var map = {
	"./ARCH_01.jpg": "aea2",
	"./ARCH_01_prew.jpg": "d3c5",
	"./ARCH_02.jpg": "2094",
	"./ARCH_02_prew.jpg": "cd13",
	"./ARCH_03.jpg": "70f2",
	"./ARCH_03_prew.jpg": "0983",
	"./ARCH_04.jpg": "8724",
	"./ARCH_04_prew.jpg": "411d",
	"./ARCH_05_video_prew.jpg": "1e57",
	"./ARCH_06.jpg": "f758",
	"./ARCH_06_prew.jpg": "f6fe",
	"./ARCH_07.jpg": "db24",
	"./ARCH_07_prew.jpg": "f222",
	"./ARCH_08.jpg": "b37d",
	"./ARCH_08_prew.jpg": "189c",
	"./ARCH_09.jpg": "ef12",
	"./ARCH_09_prew.jpg": "4c1d",
	"./ARCH_10.jpg": "4afa",
	"./ARCH_10_prew.jpg": "6690",
	"./Close_popup_icon.png": "bf37",
	"./Close_popup_icon_rollover.png": "dd34",
	"./Comunicazioni_Icon.png": "5124",
	"./Confirm_Icon.png": "6689",
	"./DESIGN_01.jpg": "71d0",
	"./DESIGN_01_prew.jpg": "0f4e",
	"./DESIGN_02_video_prew.jpg": "9f0a",
	"./DESIGN_03.jpg": "62e5",
	"./DESIGN_03_prew.jpg": "dbb7",
	"./DESIGN_04.jpg": "4301",
	"./DESIGN_04_prew.jpg": "1edb",
	"./DESIGN_05.jpg": "5e3a",
	"./DESIGN_05_prew.jpg": "5e3d",
	"./DESIGN_06.jpg": "d7a5",
	"./DESIGN_06_prew.jpg": "2487",
	"./DESIGN_07.jpg": "2ecf",
	"./DESIGN_07_prew.jpg": "212c",
	"./DESIGN_08.jpg": "f9e7",
	"./DESIGN_08_prew.jpg": "139b",
	"./DESIGN_09.jpg": "6ba8",
	"./DESIGN_09_prew.jpg": "f713",
	"./DESIGN_10_video_prew.jpg": "060e",
	"./INDUSTRIA_01.jpg": "ad9c",
	"./INDUSTRIA_01_prew.jpg": "3d94",
	"./INDUSTRIA_02.jpg": "ba03",
	"./INDUSTRIA_02_prew.jpg": "4530",
	"./INDUSTRIA_03.jpg": "68a0",
	"./INDUSTRIA_03_prew.jpg": "91d2",
	"./INDUSTRIA_04.jpg": "d9a0",
	"./INDUSTRIA_04_prew.jpg": "ad44",
	"./INDUSTRIA_05_video_prew.jpg": "a10c",
	"./INDUSTRIA_06.jpg": "618b",
	"./INDUSTRIA_06_prew.jpg": "bcd3",
	"./INDUSTRIA_07.jpg": "c6ad",
	"./INDUSTRIA_07_prew.jpg": "6c98",
	"./INDUSTRIA_08.jpg": "d847",
	"./INDUSTRIA_08_prew.jpg": "ae15",
	"./INDUSTRIA_09_video_prew.jpg": "ce3c",
	"./INDUSTRIA_10.jpg": "e8e9",
	"./INDUSTRIA_10_prew.jpg": "e9e9",
	"./Immagini_3D_Icon.png": "2c33",
	"./Nuove_Tecnologie_Icon.png": "853f",
	"./Sezione_Architettura.jpg": "e227",
	"./Sezione_Design.jpg": "df07",
	"./Sezione_Industria.jpg": "6db2",
	"./Sezione_Industria_02.jpg": "2d13",
	"./Slider_Architettura.jpg": "f3fb",
	"./Slider_Design.jpg": "26f9",
	"./Slider_Industria.jpg": "d8ba",
	"./Video_3D_Icon.png": "62a0",
	"./arch1.png": "49df",
	"./bath.png": "e0c7",
	"./burger.png": "d957",
	"./compax-white.png": "0a86",
	"./compax.png": "3cb1",
	"./email.png": "d502",
	"./facebook.png": "5b2d",
	"./file-0.png": "d0cc",
	"./file-105.png": "b8d4",
	"./file-11.png": "a8f6",
	"./file-111.png": "cadd",
	"./file-117.png": "8722",
	"./file-12.png": "4e39",
	"./file-77.png": "1bd8",
	"./file-87.png": "b16b",
	"./file-88.png": "911c",
	"./file-89.png": "1899",
	"./file-90.png": "d800",
	"./g1.png": "ecc2",
	"./g10.png": "0702",
	"./g2.png": "f577",
	"./g3.png": "0fa5",
	"./g4.png": "9518",
	"./g5.png": "3c7e",
	"./g6.png": "5655",
	"./g7.png": "0464",
	"./g8.png": "e539",
	"./g9.png": "0f0a",
	"./hero.jpg": "7928",
	"./industry.png": "bafc",
	"./instagram.png": "cda7",
	"./logo.png": "9d64",
	"./machine-white.png": "93ae",
	"./machine.png": "9e26",
	"./menu.png": "11ab",
	"./message.png": "9686",
	"./mountain.png": "abe2",
	"./pencil-white.png": "1dc5",
	"./pencil.png": "c2d1",
	"./phone.png": "1e37",
	"./play.png": "c4bf",
	"./plus.png": "cf27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";